import React from "react";
import ProfilePic from "@irati/ui/src/ProfilePicture";
import { ProfileContainer, OuterContainer, ProfileBorder } from "./styled";
export var DEFAULT_SIZE = 150;
export var DEFAULT_BORDER_SIZE = 10;
var Profile = function (_a) {
    var user = _a.user, size = _a.size, border = _a.border;
    return (React.createElement(ProfileContainer, { size: size },
        React.createElement(OuterContainer, { size: size },
            React.createElement(ProfileBorder, { size: size, border: border },
                React.createElement(ProfilePic, { user: user, size: size - border + "px" })))));
};
Profile.defaultProps = {
    size: DEFAULT_SIZE,
    border: DEFAULT_BORDER_SIZE
};
export default Profile;
